import { Dropdown } from '@/components/sgBootstrapReactWrapper';
import type { OtherServicesURLs } from '@/config/AppConfig';
import { useAppSelector } from '@/store/hooks';
import { hasAccessToEntity } from '@/store/user/userSlice';
import { FormattedMessage } from 'react-intl';
import { OtherServicesDropdownitem } from './OtherServicesDropdownItem';

const otherServices = [
  'crunchLab',
  'docstore',
  'ecredapp',
  'inApp',
  'jordan',
  'maks',
  'myclaims',
  'pipeline',
  'record',
  'sam',
  'sgworkflow',
] satisfies (keyof OtherServicesURLs)[];

function OtherServicesDropdown() {
  const isPartOfLUX = useAppSelector((state) => hasAccessToEntity(state, 'LUX'));
  const isPartOfMCO = useAppSelector((state) => hasAccessToEntity(state, 'MCO'));

  if (!(isPartOfLUX || isPartOfMCO)) {
    // improbable yet to handle
    return null;
  }

  const isPartOfLUXAndMON = isPartOfLUX && isPartOfMCO;

  return (
    <Dropdown purpose="link">
      <Dropdown.Toggle className="navbar-link dropdown-toggle">
        <FormattedMessage id="otherServices" />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {isPartOfLUXAndMON && (
          <Dropdown.Item purpose="title">
            <FormattedMessage id="entity.LUX" />
          </Dropdown.Item>
        )}
        {isPartOfLUX &&
          otherServices.map((service) => (
            <OtherServicesDropdownitem key={service} entity="LUX" service={service} />
          ))}
        {isPartOfLUXAndMON && (
          <Dropdown.Item purpose="title">
            <FormattedMessage id="entity.MCO" />
          </Dropdown.Item>
        )}
        {isPartOfMCO &&
          otherServices.map((service) => (
            <OtherServicesDropdownitem key={service} entity="MCO" service={service} />
          ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default OtherServicesDropdown;
